module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-sidenav', {
    ref: "projectSettingsNav",
    staticClass: "md-left"
  }, [_c('md-dialog-confirm', {
    ref: "duplicateProjectDialog",
    attrs: {
      "md-title": _vm.confirmDuplicateProject.title,
      "md-content-html": _vm.getConfirmContentDuplicateProject(),
      "md-ok-text": _vm.confirmDuplicateProject.ok,
      "md-cancel-text": _vm.confirmDuplicateProject.cancel
    },
    on: {
      "close": _vm.duplicateProjectConfirm
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "duplicateProjectLegacyDialog",
    attrs: {
      "md-title": _vm.confirmDuplicateProject.title,
      "md-content-html": _vm.getConfirmContentDuplicateLegacyProject(),
      "md-ok-text": _vm.confirmDuplicateProject.ok,
      "md-cancel-text": _vm.confirmDuplicateProject.cancel
    },
    on: {
      "close": _vm.duplicateProjectConfirm
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "deleteProjectDialog",
    attrs: {
      "md-title": _vm.confirm.title,
      "md-content-html": _vm.getConfirmContent(),
      "md-ok-text": _vm.confirm.ok,
      "md-cancel-text": _vm.confirm.cancel
    },
    on: {
      "close": _vm.deleteProjectConfirm
    }
  }), _vm._v(" "), _c('md-toolbar', {
    staticClass: "md-dense main-toolbar"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Project Settings")])], 1), _vm._v(" "), (_vm.isAdministrator) ? _c('md-layout', {
    attrs: {
      "md-flex": "90",
      "md-flex-offset": "5"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.open.apply(null, arguments)
      }
    }
  }, [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Project Name")]), _vm._v(" "), _c('md-input-container', [_c('md-input', {
    attrs: {
      "disabled": !_vm.activeProjectEntitled
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "disabled": !_vm.activeProjectEntitled
    },
    on: {
      "click": _vm.updateTitle
    }
  }, [_vm._v("Rename")])], 1), _vm._v(" "), _c('form', {
    staticClass: "project-poster-form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.open.apply(null, arguments)
      }
    }
  }, [(!_vm.project.posterUrl) ? _c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Add Project Image")]) : _c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Project Image")]), _vm._v(" "), (!_vm.project.posterUrl) ? _c('div', [_c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "disabled": !_vm.activeProjectEntitled
    },
    on: {
      "click": _vm.uploadPoster
    }
  }, [_vm._v("Upload")])], 1) : _c('div', [_c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "disabled": !_vm.activeProjectEntitled
    },
    on: {
      "click": _vm.changePoster
    }
  }, [_vm._v("Change")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "disabled": !_vm.activeProjectEntitled
    },
    on: {
      "click": _vm.removePoster
    }
  }, [_vm._v("Remove")])], 1)])]) : _c('md-layout', {
    attrs: {
      "md-column": "",
      "md-flex": "90",
      "md-flex-offset": "5"
    }
  }, [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Project Name")]), _vm._v(" "), _c('span', {
    staticClass: "md-body-2"
  }, [_vm._v(_vm._s(_vm.project.title))])]), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "margin-top": "1rem"
    },
    attrs: {
      "md-column": "",
      "md-flex": "90",
      "md-flex-offset": "5"
    }
  }, [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Default Cue Placement")]), _vm._v(" "), _c('form', {
    staticClass: "project-cue-placement-form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.open.apply(null, arguments)
      }
    }
  }, [_c('div', [_c('md-radio', {
    staticClass: "md-primary",
    attrs: {
      "mdValue": "left"
    },
    on: {
      "change": _vm.changeCuePlacement
    },
    model: {
      value: (_vm.projectCuePlacement),
      callback: function($$v) {
        _vm.projectCuePlacement = $$v
      },
      expression: "projectCuePlacement"
    }
  }, [_vm._v(" Left side of page")]), _c('br'), _vm._v(" "), _c('md-radio', {
    staticClass: "md-primary",
    attrs: {
      "mdValue": "right"
    },
    on: {
      "change": _vm.changeCuePlacement
    },
    model: {
      value: (_vm.projectCuePlacement),
      callback: function($$v) {
        _vm.projectCuePlacement = $$v
      },
      expression: "projectCuePlacement"
    }
  }, [_vm._v(" Right side of page")]), _c('br')], 1)])]), _vm._v(" "), (_vm.ownerCanLock) ? _c('md-layout', {
    staticStyle: {
      "margin-top": "1rem"
    },
    attrs: {
      "md-column": "",
      "md-flex": "90",
      "md-flex-offset": "5"
    }
  }, [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Duplicate Settings")]), _vm._v(" "), _c('md-switch', {
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px"
    },
    attrs: {
      "id": "locked",
      "name": "locked"
    },
    on: {
      "change": _vm.toggleLockedDuplicateSetting
    },
    model: {
      value: (_vm.duplicateSetting),
      callback: function($$v) {
        _vm.duplicateSetting = $$v
      },
      expression: "duplicateSetting"
    }
  }, [_vm._v("Locked")]), _vm._v(" "), _c('p', [_vm._v("When project is locked, only the owner can duplicate it. Unlocked projects can be duplicated by all collaborators.")]), _vm._v(" "), (_vm.activeProjectEntitled) ? _c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "disabled": !_vm.canCreateProject || _vm.duplicateProjectButtonLoading
    },
    on: {
      "click": function($event) {
        return _vm.duplicateProject($event)
      }
    }
  }, [_vm._v("Duplicate Project")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.project.duplicateSetting && _vm.user.uid !== _vm.project.ownerUID && _vm.project.title !== 'Sample Project') ? _c('md-layout', {
    attrs: {
      "md-column": "",
      "md-flex": "90",
      "md-flex-offset": "5"
    }
  }, [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Duplicate Settings")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "disabled": !_vm.canCreateProject || _vm.duplicateProjectButtonLoading
    },
    on: {
      "click": function($event) {
        return _vm.duplicateProject($event)
      }
    }
  }, [_vm._v("Duplicate Project")])], 1) : _vm._e(), _vm._v(" "), (_vm.showPassLine || _vm.offerShowPass) ? _c('div', {
    staticClass: "showpass-section"
  }, [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Show Pass")]), _vm._v(" "), (_vm.showPassLine) ? _c('p', {
    staticClass: "showpass-line"
  }, [_vm._v(_vm._s(_vm.showPassLine))]) : _vm._e(), _vm._v(" "), _c('use-show-pass', {
    attrs: {
      "variant": "settings"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showNotesListIntegration) ? _c('div', {
    staticClass: "noteslist-section"
  }, [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Show Sync")]), _vm._v(" "), (_vm.notesListAccountStatusLoading) ? _c('div', {
    staticClass: "noteslist-link-loading"
  }, [_vm._v("\n            Checking Notes List connection…\n        ")]) : [_c('p', {
    staticClass: "md-body-1 noteslist-status-row"
  }, [_c('strong', [_vm._v("Status:")]), _vm._v(" "), _c('span', {
    staticClass: "noteslist-account-badge",
    class: _vm.notesListBadgeClass
  }, [_vm._v(_vm._s(_vm.notesListBadgeLabel))])]), _vm._v(" "), (_vm.isNotesListLinked && _vm.project.noteslist_production_id) ? _c('p', {
    staticClass: "md-body-1"
  }, [_c('strong', [_vm._v("Production ID:")]), _vm._v(" " + _vm._s(_vm.project.noteslist_production_id) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isNotesListLinked && _vm.notesListLinkedAtLabel) ? _c('p', {
    staticClass: "md-body-1"
  }, [_c('strong', [_vm._v("Linked On:")]), _vm._v(" " + _vm._s(_vm.notesListLinkedAtLabel) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isNotesListLinked) ? _c('p', {
    staticClass: "md-body-1"
  }, [_c('strong', [_vm._v("Last sync:")]), _vm._v(" " + _vm._s(_vm.notesListLastSyncLabel) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.notesListSyncError) ? _c('p', {
    staticClass: "md-body-1 noteslist-sync-error"
  }, [_vm._v("\n                " + _vm._s(_vm.notesListSyncError) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isNotesListLinked) ? _c('div', {
    staticClass: "noteslist-integration-actions"
  }, [_c('md-button', {
    key: 'nl-disconnect-' + (_vm.notesListLinkWorking ? 'busy' : 'idle'),
    staticClass: "md-raised",
    attrs: {
      "disabled": _vm.notesListLinkWorking
    },
    on: {
      "click": _vm.openNotesListUnlinkDialog
    }
  }, [_c('span', {
    staticClass: "noteslist-btn-content"
  }, [_vm._v("\n                        Disconnect\n                        "), (_vm.notesListLinkWorking && _vm.notesListActiveAction === 'disconnect') ? _c('span', {
    staticClass: "noteslist-btn-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('md-button', {
    key: 'nl-resync-' + (_vm.notesListLinkWorking ? 'busy' : 'idle'),
    staticClass: "md-raised md-primary",
    attrs: {
      "disabled": _vm.notesListLinkWorking
    },
    on: {
      "click": _vm.handleNotesListResyncOrUpgrade
    }
  }, [_c('span', {
    staticClass: "noteslist-btn-content"
  }, [_vm._v("\n                        Re-sync\n                        "), (_vm.notesListLinkWorking && _vm.notesListActiveAction === 'resync') ? _c('span', {
    staticClass: "noteslist-btn-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])])], 1) : _c('div', [(_vm.notesListLinkAccessLoading) ? _c('div', {
    staticClass: "noteslist-link-loading"
  }, [_vm._v("\n                    Checking subscription status…\n                ")]) : (_vm.notesListLinkingDisabled) ? _c('div', {
    staticClass: "noteslist-subscription-alert",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Subscription required")]), _vm._v(" "), _c('p', {
    staticClass: "noteslist-subscription-alert-message"
  }, [_vm._v(_vm._s(_vm.notesListLinkAccessMessage))])]) : _c('div', [_c('p', {
    staticClass: "md-body-1 noteslist-connect-copy"
  }, [_vm._v("\n                        Connect this project to a Notes List production to sync cue and script context.\n                    ")]), _vm._v(" "), (_vm.notesListProductionsLoading) ? _c('div', {
    staticClass: "noteslist-link-loading"
  }, [_vm._v("\n                        Loading productions…\n                    ")]) : _c('div', [(_vm.notesListProductions.length) ? _c('div', {
    staticClass: "noteslist-production-picker"
  }, [_c('label', {
    staticClass: "md-body-1",
    attrs: {
      "for": "noteslist-production-select"
    }
  }, [_vm._v("Choose a production")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notesListSelectedProductionId),
      expression: "notesListSelectedProductionId"
    }],
    staticClass: "noteslist-production-select",
    attrs: {
      "id": "noteslist-production-select"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.notesListSelectedProductionId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a production...")]), _vm._v(" "), _vm._l((_vm.notesListProductions), function(production) {
    return _c('option', {
      key: production.id,
      domProps: {
        "value": production.id
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm.notesListProductionLabel(production)) + "\n                                ")])
  })], 2)]) : _c('p', {
    staticClass: "md-body-1 noteslist-link-hint"
  }, [_vm._v("\n                            No available unlinked productions found. Create a new one below.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "noteslist-connection-actions"
  }, [_c('md-button', {
    key: 'nl-connect-' + (_vm.notesListLinkWorking ? 'busy' : 'idle'),
    staticClass: "md-raised md-primary",
    attrs: {
      "disabled": _vm.notesListLinkWorking || !_vm.notesListSelectedProductionId
    },
    on: {
      "click": _vm.confirmNotesListLinkInline
    }
  }, [_c('span', {
    staticClass: "noteslist-btn-content"
  }, [_vm._v("\n                                    Connect\n                                    "), (_vm.notesListLinkWorking && _vm.notesListActiveAction === 'connect') ? _c('span', {
    staticClass: "noteslist-btn-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticClass: "noteslist-or-divider"
  }, [_vm._v("or")]), _vm._v(" "), _c('md-button', {
    key: 'nl-create-' + (_vm.notesListLinkWorking ? 'busy' : 'idle'),
    staticClass: "md-raised",
    attrs: {
      "disabled": _vm.notesListLinkWorking
    },
    on: {
      "click": _vm.confirmNotesListCreateInline
    }
  }, [_c('span', {
    staticClass: "noteslist-btn-content"
  }, [_vm._v("\n                                    Create production\n                                    "), (_vm.notesListLinkWorking && _vm.notesListActiveAction === 'create') ? _c('span', {
    staticClass: "noteslist-btn-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])])], 1)])])])]], 2) : _vm._e(), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "deletePagesDialog",
    attrs: {
      "md-title": _vm.deletePagesConfirm.title,
      "md-content-html": _vm.getDeletePagesConfirmContent(),
      "md-ok-text": _vm.deletePagesConfirm.ok,
      "md-cancel-text": _vm.deletePagesConfirm.cancel
    },
    on: {
      "close": _vm.confirmDeletePages
    }
  }), _vm._v(" "), _c('md-dialog', {
    ref: "upload-poster-dialog"
  }, [_c('md-dialog-title', [_vm._v("Project Image Upload")]), _vm._v(" "), _c('md-dialog-content', [_c('span', [_vm._v("JPG, GIF or PNG images no larger than 1MB. For best results, upload a square image.")]), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "poster-file-input"
    }
  }, [_vm._v("Image File")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "id": "poster-file-input",
      "required": "",
      "accept": "image/*"
    },
    on: {
      "selected": _vm.onPosterFileChange
    }
  })], 1)], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.cancelSubmitPosterImage()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    attrs: {
      "disabled": !_vm.validPoster || _vm.uploadingPoster
    },
    on: {
      "click": function($event) {
        return _vm.submitPosterImage()
      }
    }
  }, [_vm._v("Upload")])], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "remove-poster-dialog",
    attrs: {
      "md-title": _vm.removePosterConfirm.title,
      "md-content-html": _vm.removePosterConfirm.description,
      "md-ok-text": _vm.removePosterConfirm.ok,
      "md-cancel-text": _vm.removePosterConfirm.cancel
    },
    on: {
      "close": _vm.confirmRemovePoster
    }
  }), _vm._v(" "), _c('md-dialog', {
    ref: "noteslist-account-required-dialog"
  }, [_c('md-dialog-title', [_vm._v("Connect your Notes List account")]), _vm._v(" "), _c('md-dialog-content', [_c('p', {
    staticClass: "md-body-1"
  }, [_vm._v("\n                Link your Notes List account in Account Settings before connecting this project.\n            ")])]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.closeNotesListAccountRequiredDialog
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.goToAccountSettingsForNotesList
    }
  }, [_vm._v("Account settings")])], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "noteslist-unlink-dialog",
    staticClass: "noteslist-disconnect-dialog",
    class: {
      'show-md-dark-mode': _vm.showMode
    },
    attrs: {
      "md-title": "Disconnect from The Notes List?",
      "md-content-html": "Stops sync between this project and the linked production. Notes in The Notes List are not deleted.",
      "md-ok-text": "Disconnect",
      "md-cancel-text": "Cancel"
    },
    on: {
      "close": _vm.confirmNotesListUnlink
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3615a70","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project-settings/nav.vue
// module id = 1293
// module chunks = 21